import { URL_PREFIX } from 'ev-config/config';

export enum AdminPaths {
  Workflows = 'workflows',
  PagesFrontDoorBuilder = 'front_door_builder',
  PagesDocuments = 'documents',
  PagesForms = 'forms',
  PagesFormEditor = 'form_editor',
  PagesDocumentEditor = 'document_editor',
  PagesClinical = 'clinical',
  PagesPatient = 'patient',
  PagesMessages = 'messages',
  PagesClinicalQueue = 'queue',
  PagesClinicalEmbeddedQueue = 'embedded_queue',
  PagesClinicalPatient = 'patient',
  PagesClinicalVisitHistory = 'visit_history',
  PagesClinicalScheduling = 'scheduling',
  PagesClinicalVisitDetails = 'clinical_visit_details',
  PagesPatientNavigationMenu = 'navigation_menu',
  PagesPatientVisitDetails = 'patient_visit_details',
  Customize = 'customize',
  Roles = 'roles',
  Users = 'physicians',
  Settings = 'settings',
  ConnectedDevices = 'connected_devices',
  VideoBackground = 'video_background',
  InterpreterServices = 'interpreter_services',
  TelephonyServices = 'telephony_services',
}

export const ADMIN_ROOT = `${URL_PREFIX}/app_admin`;
